import React from 'react'
import { useAuth } from 'Hooks'
import Loading from 'Components/loading'
import Approutes from './Routes'

function App() {
  const { isLoading } = useAuth()

  if (isLoading) {
    return <Loading />
  }

  return <Approutes />
}

export default App
